import axios from "axios";
import { Message } from "element-ui";

/**
 * 接口地址。默认保持原有硬编码（行为不变），
 * 需要换环境时在控制台执行 localStorage.setItem("apiBase", "https://xxx/") 即可覆盖。
 */
// const DEFAULT_API_BASE = "http://127.0.0.1:8080/";
const DEFAULT_API_BASE = "https://www.yghby.com/proxy_api";
const request = axios.create({
  // baseURL: "http://1.94.19.12:8080/",
  baseURL: window.__API_BASE__ || localStorage.getItem("apiBase") || DEFAULT_API_BASE,
  headers: { Authorization: localStorage.getItem("token") },
});
//post请求的请求头
// service.defaults.headers.post["Content-Type"] = "application/json";
//axios请求拦截器
request.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `${token}`;
    }

    // console.log("请求---config---", config);

    return config;
  },
  (error) => {
    // console.log("请求---error---", error);

    return Promise.reject(error); //在axios的catch中写入报错后回调
  }
);

// ==================== 登录失效处理（2026-09-21 修复 / 2026-10-07 增强） ====================
// 原实现无条件把 location 指向根路径做整页硬跳转：
//   登录页 → 请求 501 → 跳根路径 → 整页重载 → 再次 501 → 无限刷新。
// 现改为：已在登录页则**不再跳转**，其余场景用 replace 跳一次，并加幂等锁。
// 🔴 10-07 增强（F5 场景复现）：token 过期后刷新页面，Vue Router 的**首次导航
//    （异步 chunk 加载中）尚未完成**，此时 501 → replace("#/login") 成功改了 hash，
//    但首次导航完成时 Router 会用 replaceState 把 URL **改回原路径**（无 hashchange、
//    无声覆盖），页面仍停在原页。SPA 内操作时 Router 空闲所以能正常跳，唯独刷新场景翻车。
//    修复：跳转后轮询确认 hash 真正落在 #/login；发现被覆盖就重试（连续 2 次稳定才算到位）。
let loginRedirecting = false;

/** 当前是否已在登录页（本项目为 hash 路由，形如 #/login） */
function onLoginPage() {
  const hash = window.location.hash || "";
  if (hash === "#/login" || hash.indexOf("#/login?") === 0) return true;
  // 兼容 history 模式部署
  return window.location.pathname === "/login";
}

function redirectToLogin() {
  if (onLoginPage()) return; // 已在登录页：静默处理，绝不再次跳转
  if (loginRedirecting) return; // 并发多个 501 只跳一次
  loginRedirecting = true;
  Message.error("登录已超时，请重新登录");
  const go = () =>
    window.location.replace(
      window.location.origin + window.location.pathname + "#/login"
    );
  go();
  let tries = 0;
  let stable = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (tries > 20) {
      clearInterval(timer); // 6s 兜底：Router 首次导航再慢也该结束了
      return;
    }
    if (onLoginPage()) {
      stable += 1;
      if (stable >= 2) clearInterval(timer); // 连续 2 次确认稳定，防「刚到位又被覆盖」
      return;
    }
    stable = 0;
    go(); // 被 Router 的 replaceState 覆盖回去了 → 重跳
  }, 300);
}

//响应拦截
request.interceptors.response.use(
  (response) => {
    // console.log("响应---response---", response);

    // RBAC：统一按业务码处理（HTTP 恒为 200）
    const body =
      response.data && typeof response.data === "object" ? response.data : {};
    const code = body.code == null ? "" : String(body.code);

    // 501 / 登录超时 → 清登录态并跳登录页（已在登录页则不跳，避免刷新死循环）
    if (code === "501" || body.message == "登录超时，请重新登录") {
      localStorage.removeItem("token");
      localStorage.removeItem("permInfo");
      redirectToLogin();
      return Promise.reject(response);
    }

    // 304 = 已登录但无权限：只提示，不跳转
    if (code === "304") {
      Message.error(body.message || "无操作权限");
      return Promise.reject(response);
    }

    // let err_text = "";
    // if (response.status === 200) {
    //   if (response.data.err_code === 0) {
    //     return Promise.resolve(response);
    //   } else {
    //     // 根据返回的code值来做不同的处理（和后端约定）
    //     switch (response.data.err_code) {
    //       case 2101:
    //         // err_text = "用户不存在或停用";
    //         break;
    //       default:
    //       // err_text = response.data.msg;
    //       // this.$message({
    //       //   type: "warning",
    //       //   message: err_text || "服务正在维护，请等待......",
    //       // });
    //     }
    //     return Promise.reject(response);
    //   }
    // }

    return response;
  },
  (error) => {
    console.log("响应---error---", error);

    //其他异常
    // if (error && error.response) {
    //   switch (error.response.status) {
    //     case 400:
    //       // this.$message({
    //       //   type: "warning",
    //       //   message: `${
    //       //     error.response.data.message || error.response.data.msg
    //       //   }`,
    //       // });
    //       break;
    //     default:
    //     // this.$message({ type: "warning", message: "服务异常！" });
    //   }
    // }
    return Promise.reject(error); //在axios的catch中写入报错后回调
  }
);
export default request;

/**
 * 取当前 API 基址（去掉尾部斜杠）。
 *
 * 用途：`<img src>`、`window.open` 这类**不走 axios** 的请求拿不到统一 baseURL，
 * 需要自己拼完整地址。例如后端返回相对路径 `/ops/photo/view/12?thumb=1&sig=xx`，
 * 前端拼成 `getApiBase() + that`。（注意：`<img>` 也带不了 token，故照片走 URL 签名。）
 */
export function getApiBase() {
  const base = window.__API_BASE__ || localStorage.getItem("apiBase") || DEFAULT_API_BASE;
  return String(base).replace(/\/+$/, "");
}
